const user = {
  USER: 'USER',
  USERS: 'USERS'
}
export { user }
